import { deleteData, getData, postData, putData } from "../apiClient";

const ItemName = "Loan Installment";
const API_URL = "loan-installment";

// Get all with pagination
export const GetAll = async (
    { page = 1, limit = 10, search = "" },
    signal = null,
) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search,
        });

        const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error(`Get ${ItemName} with pagination API error:`, error);
        return {
            success: false,
            ...error,
        };
    }
};

// Get single loan installment by ID
export const GetById = async (id) => {
    try {
        const result = await getData(`/${API_URL}/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get ${ItemName} data API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// Create loan installment
export const Create = async ({ data }) => {
    try {
        const result = await postData(`/${API_URL}/`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(
            `Create ${ItemName} API error:`,
            error.status === 400 ? error.error : error.message,
        );
        return {
            data: {
                success: false,
                error:
                    error.status === 400
                        ? error.data?.error || error.data?.message
                        : error.message,
                status: error.status,
            },
        };
    }
};

// Update loan installment
export const Update = async ({ id, data }) => {
    try {
        const result = await putData(`/${API_URL}/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error(`Update ${ItemName} API error:`, error);
        return {
            data: {
                success: false,
                error:
                    error.status === 400
                        ? error.data?.error || error.data?.message
                        : error.message,
                status: error.status,
            },
        };
    }
};

// Delete loan installment
export const Delete = async ({ id }) => {
    try {
        const result = await deleteData(`/${API_URL}/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Delete ${ItemName} API error:`, error);
        return {
            data: {
                success: false,
                ...error,
            },
        };
    }
};

// Get employees list for dropdown
export const GetEmployeeList = async (type = null, installmentId = null) => {
    try {
        let url = `/${API_URL}/get-employees/list`;
        const params = new URLSearchParams();
        if (type) params.append("type", type);
        if (installmentId) params.append("installmentId", installmentId);
        
        const queryString = params.toString();
        if (queryString) url += `?${queryString}`;

        const result = await getData(url);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get Employees for ${ItemName} API error:`, error);
        return {
            data: {
                success: false,
                ...error,
            },
        };
    }
};

// Get active loans by employee
export const GetActiveLoansByEmployee = async (employeeId, installmentId = null) => {
    try {
        let url = `/${API_URL}/active-loans/${employeeId}`;
        if (installmentId) {
            url += `?installmentId=${installmentId}`;
        }
        const result = await getData(url);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get Active Loans for ${ItemName} API error:`, error);
        return {
            data: {
                success: false,
                ...error,
            },
        };
    }
};
